module.exports = __webpack_public_path__ + "img/framenew_box04.fbc4a155.jpg";